import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'loyal-react'

const Form = props => {
  return (
    <div className='shippingNotCalculated col-7 col-md-4 mt-1 mt-md-0'>
      <div className='row'>
        <Input
          id='zipCode'
          label='CEP'
          className='col-12 pr-half'
          value={props.zipCode}
          onChange={props.handleZipCodeChange}
          valid={props.zipCode}
          onBlur={this.validateZipCode}
          mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
          data-error='Digite um CEP válido'
        />
      </div>
    </div>
  )
}

Form.propTypes = {
  zipCode: PropTypes.string,
  handleZipCodeChange: PropTypes.func.isRequired
}

export default Form



// WEBPACK FOOTER //
// ./src/features/Cart/List/ShippingCalculator/Form/Form.js